import { InquiryOverviewPageStyle } from "@pages/inquiryOverviewPage/inquiryOverviewPageStyle";
import styled from "styled-components";

export const IncidentOverviewPageStyle = styled(InquiryOverviewPageStyle)`

`;
